export const FETCH_QUEUE = 'framl/landing/FETCH_QUEUE';
export const FETCH_QUEUE_SUCCESS = 'framl/landing/FETCH_QUEUE_SUCCESS';
export const FETCH_QUEUE_FAILURE = 'framl/landing/FETCH_QUEUE_FAILURE';
export const FETCH_CUSTOMER_ALERTS = 'framl/landing/FETCH_CUSTOMER_ALERTS';
export const FETCH_CUSTOMER_ALERTS_SUCCESS =
  'framl/landing/FETCH_CUSTOMER_ALERTS_SUCCESS';
// FIN-13005 — a failed per-customer expand used to be swallowed in the saga, so the panel
// rendered its empty state and the row read "Underlying Alerts (0)". An outright fetch failure
// and a genuinely empty snapshot are different facts and must look different.
export const FETCH_CUSTOMER_ALERTS_FAILURE =
  'framl/landing/FETCH_CUSTOMER_ALERTS_FAILURE';
export const SET_FILTERS = 'framl/landing/SET_FILTERS';
export const SET_SORT = 'framl/landing/SET_SORT';
export const SET_PAGE = 'framl/landing/SET_PAGE';
export const SET_SIZE = 'framl/landing/SET_SIZE';
// FIN-13938 — expanded queue rows live in the slice (not antd's internal state) so they survive a
// round trip to the case page and back.
export const SET_EXPANDED_ROW_KEYS = 'framl/landing/SET_EXPANDED_ROW_KEYS';
// FIN-13958 — Create Case / Merge to Case across the selected customers as ONE action: the saga runs
// one BE request per customer and reports ONE folded outcome (see pages/framl/landing/bulkCaseOutcome).
export const CREATE_CASES_FOR_CUSTOMERS =
  'framl/landing/CREATE_CASES_FOR_CUSTOMERS';
export const MERGE_CASES_FOR_CUSTOMERS =
  'framl/landing/MERGE_CASES_FOR_CUSTOMERS';
export const BULK_CASE_OUTCOME = 'framl/landing/BULK_CASE_OUTCOME';
export const CLEAR_BULK_CASE_OUTCOME = 'framl/landing/CLEAR_BULK_CASE_OUTCOME';
export const DOWNLOAD_FRAML_QUEUE_EXPORT =
  'framl/landing/DOWNLOAD_FRAML_QUEUE_EXPORT';
export const DOWNLOAD_FRAML_QUEUE_EXPORT_SUCCESS =
  'framl/landing/DOWNLOAD_FRAML_QUEUE_EXPORT_SUCCESS';
export const DOWNLOAD_FRAML_QUEUE_EXPORT_FAIL =
  'framl/landing/DOWNLOAD_FRAML_QUEUE_EXPORT_FAIL';

export const fetchQueue = (payload) => ({ type: FETCH_QUEUE, payload });

export const fetchQueueSuccess = (payload) => ({
  type: FETCH_QUEUE_SUCCESS,
  payload
});

export const fetchQueueFailure = (error) => ({
  type: FETCH_QUEUE_FAILURE,
  payload: error
});

// FIN-12887: server-paged expand — page/size ride along; the saga defaults them.
export const fetchCustomerAlerts = (customerKey, page = 0, size = 20) => ({
  type: FETCH_CUSTOMER_ALERTS,
  payload: { customerKey, page, size }
});

export const fetchCustomerAlertsFailure = (customerKey, error) => ({
  type: FETCH_CUSTOMER_ALERTS_FAILURE,
  payload: { customerKey, error: error?.message || String(error || 'error') }
});

// alerts = current page's items; total/page/size = the envelope's paging meta.
export const fetchCustomerAlertsSuccess = (
  customerKey,
  alerts,
  { total, page, size } = {}
) => ({
  type: FETCH_CUSTOMER_ALERTS_SUCCESS,
  payload: {
    customerKey,
    alerts,
    total: total ?? (alerts || []).length,
    page: page ?? 0,
    size: size ?? (alerts || []).length
  }
});

export const setFilters = (filters) => ({
  type: SET_FILTERS,
  payload: filters
});

export const setSort = (sort) => ({ type: SET_SORT, payload: sort });

export const setPage = (page) => ({ type: SET_PAGE, payload: { page } });
export const setSize = (size) => ({ type: SET_SIZE, payload: { size } });
export const setExpandedRowKeys = (keys) => ({
  type: SET_EXPANDED_ROW_KEYS,
  payload: { keys }
});

// plans: [{ customerKey, alertIds }]
// alreadyCased: [{ alertId, caseId }] — selected alerts left out of the plans because they are
// already in a case; reported in the outcome as skipped.
export const createCasesForCustomers = ({
  plans,
  departmentId,
  caseType,
  alreadyCased
}) => ({
  type: CREATE_CASES_FOR_CUSTOMERS,
  payload: { plans, departmentId, caseType, alreadyCased }
});
// plans: [{ customerKey, alertIds, caseId }]
export const mergeCasesForCustomers = ({ plans, alreadyCased }) => ({
  type: MERGE_CASES_FOR_CUSTOMERS,
  payload: { plans, alreadyCased }
});
export const bulkCaseOutcome = (outcome) => ({
  type: BULK_CASE_OUTCOME,
  payload: outcome
});
export const clearBulkCaseOutcome = () => ({ type: CLEAR_BULK_CASE_OUTCOME });

// FIN-11360 — FRAML View queue CSV export (current-page blob or "download all" job).
export const downloadFramlQueueExport = (payload) => ({
  type: DOWNLOAD_FRAML_QUEUE_EXPORT,
  payload
});

export const downloadFramlQueueExportSuccess = (payload) => ({
  type: DOWNLOAD_FRAML_QUEUE_EXPORT_SUCCESS,
  payload
});

export const downloadFramlQueueExportFail = (payload) => ({
  type: DOWNLOAD_FRAML_QUEUE_EXPORT_FAIL,
  payload
});
